import { render, staticRenderFns } from "./IconWithQuestionExplanation.vue?vue&type=template&id=f4c88da0&scoped=true&"
import script from "./IconWithQuestionExplanation.vue?vue&type=script&lang=js&"
export * from "./IconWithQuestionExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c88da0",
  null
  
)

export default component.exports